export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20distinguished%20mature%20Chinese%20man%20in%20his%2040s%20wearing%20a%20perfectly%20tailored%20charcoal%20suit%20with%20a%20burgundy%20pocket%20square%2C%20standing%20confidently%20in%20a%20warm%20toned%20classic%20library%20with%20rich%20wooden%20bookshelves%2C%20soft%20dramatic%20lighting%20from%20a%20window%2C%20elegant%20and%20sophisticated%20atmosphere%2C%20editorial%20fashion%20photography&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="老色哥-成熟男士穿搭风格指南"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/45"></div>
      </div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <p className="text-primary-300 text-sm md:text-base font-medium tracking-widest uppercase mb-3">
          老 色 哥 社 区
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 max-w-3xl leading-tight">
          成熟男人的穿搭圣经<br />
          <span className="text-primary-400">品味男人的生活方式</span>
        </h1>
        <p className="text-base md:text-lg text-white/75 max-w-xl mb-8 leading-relaxed">
          汇聚资深穿搭达人，分享经典绅士穿搭、复古时尚搭配技巧<br className="hidden md:block" />
          帮助每一位成熟男性找回自信魅力，展现独特品味与格调
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <a
            href="/category/jingdian-shenshi"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors duration-200 whitespace-nowrap"
          >
            探索穿搭指南
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-md backdrop-blur-sm transition-colors duration-200 whitespace-nowrap"
          >
            了解老色哥
          </a>
        </div>
      </div>
    </section>
  );
}